module.exports = __webpack_public_path__ + "img/泳池.edf14516.png";